export function getLocalTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
